module.exports = __webpack_public_path__ + "img/20180128143818.c1a1518d.jpg";